<template>
  <div :class="['searchBox',{focus:onfocus}]">
    <input
      type="text"
      v-model="content"
      class="searchInput"
      @mouseup="showResult"
      placeholder="搜索"
      @focus="onfocus = true"
      @blur="onfocus = false"
      @keyup.enter="jumpSearch()"
      autocomplete='new-password'
    >
    <span
      :class="['searchBtn', 'iconfont']"
      @click="jumpSearch()"
    >&#xe633;</span>

    <ul
      class="searchResult"
      v-show="loading"
    >
      <li>
        <nuxt-link
          v-for="item in  stockList"
          :key="item.id"
          v-html="item.stockNameDisp+ '('+item.type + item.stockCode +')'"
          :to="'/stock/'+ item.type + item.stockCode"
          target="_blank"
        ></nuxt-link>
      </li>
      <li class="searchMore">
        <nuxt-link
          :to="'/search?keyword=' + content + '&type=post'"
          target="_blank"
        >更多相关股票</nuxt-link>
      </li>

      <li class="li-title">
        <nuxt-link
          v-for="item in  postList"
          :key="item.id"
          v-html="item.titleDisp"
          :to="'/p/'+ item.id"
          target="_blank"
        ></nuxt-link>
      </li>
      <li class="searchMore">
        <nuxt-link
          :to="'/search?keyword=' + content + '&type=post'"
          target="_blank"
        >更多相关文章</nuxt-link>
      </li>

      <li>
        <nuxt-link
          v-for="item in  userList"
          :key="item.userId"
          v-html="item.usernameDisp"
          :to="'/user/'+ item.userId + '?type=article'"
          target="_blank"
        ></nuxt-link>
      </li>
      <li class="searchMore">
        <nuxt-link
          :to="'/search?keyword=' + content + '&type=user'"
          target="_blank"
        >更多相关用户</nuxt-link>
      </li>
    </ul>
  </div>
</template>
<script>
import * as api from "~/api/index";
export default {
  data() {
    return {
      content: "",
      loading: false,
      postList: [],
      stockList: [],
      userList: [],
      closeLoadingTimeOut: null,
      onfocus: false
    };
  },
  watch: {
    content() {
      this.doSearch();
    }
  },
  methods: {
    showResult() {
      if (!this.content) return;
      this.loading = true;
    },
    jumpSearch() {
      if (!this.content) return;
      this.loading = false;
      this.$router.push(`/search?keyword=${this.content}&type=post`);
      // window.open("/search/post/" + this.content);
    },
    doSearch() {
      if (!this.content) return;
      this.$axios(
        api.doIndexSearch({
          keyword: this.content,
          page: 1,
          count: 5
        })
      ).then(res => {
        this.loading = true;
        this.postList =
          res.result.searchPost && res.result.searchPost.postList
            ? res.result.searchPost.postList
            : [];
        this.stockList =
          res.result.searchStock && res.result.searchStock.stockList
            ? res.result.searchStock.stockList
            : [];
        this.userList =
          res.result.searchUser && res.result.searchUser.userList
            ? res.result.searchUser.userList
            : [];
      });
    }
  },
  mounted() {
    let searchList = document.querySelector(".searchResult");
    searchList.addEventListener("mouseleave", () => {
      clearTimeout(this.closeLoadingTimeOut);
      this.closeLoadingTimeOut = setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  }
};
</script>
<style lang="less" scoped>
.searchBox {
  position: relative;
  margin-top: 15px;
  margin-left: 30px;
  display: inline-block;
  width: 190px;
  height: 40px;
  border-radius: 20px;
  background-color: #f2f3f4;
  box-sizing: border-box;
  border: 1px solid #ffffff00;
  .searchBtn {
    width: 50px;
    height: 40px;
    text-align: center;
    line-height: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0px;
    font-size: 18px;
    // margin: auto;
    line-height: 40px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    cursor: pointer;
    color: #838d97;

    box-sizing: border-box;
    z-index: 10;
  }
  .searchInput {
    box-sizing: border-box;
    display: inline-block;
    font-size: 14px;
    border: none;
    width: calc(100% - 40px);
    height: 100%;
    padding: 12px 0 13px 20px;
    border-radius: 20px;
    background-color: transparent;
    outline: none;

    &:focus {
      // border: 1px solid #1677d9;
      // background: #fff;

      &.searchResult {
        display: block;
      }
    }
  }
  .searchInput::-ms-clear {
    display: none;
  }

  .searchResult {
    position: absolute;
    width: 100%;
    min-height: 200px;
    top: 40px;
    left: 0;
    background: #fff;
    border-radius: 5px;
    box-shadow: 2px 2px 5px 2px #cccbce;

    li {
      width: 100%;
      min-height: 30px;
      line-height: 30px;

      a {
        width: 100%;
        color: #333;
        min-height: 30px;
        display: block;
        border-bottom: 1px solid #f2f3f4;
        font-size: 14px;
        padding: 0 20px;
      }
    }

    .li-title {
      line-height: 1.4;
    }

    .searchMore {
      font-size: 14px;
      text-align: center;
      display: block;
      width: 100%;
      height: 30px;
      line-height: 30px;
      background: #eee;
    }
  }
}
.focus {
  border: 1px solid #1677d9;
  outline: 2px;
  background-color: #fff;
}
</style>
